if($('.project-gallery').length) {

    $('.project-gallery').each(function () {

        let slider = $(this).find('.project-gallery-inner-container'),
            prevMobile = $(this).find('.slick-prev-mobile'),
            nextMobile = $(this).find('.slick-next-mobile');

        slider.slick({
            infinite: true,
            slidesToShow: 2,
            responsive: [
                {
                    breakpoint: 769,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ],
            prevArrow: '<button type="button" class="slick-prev"><img src="/assets/img/controls/prev-slide-arrow.svg" alt="Previous Project"></button>',
            nextArrow: '<button type="button" class="slick-next"><img src="/assets/img/controls/next-slide-arrow.svg" alt="Next Project"></button>'
        });

        prevMobile.on('click', function () { slider.slick('slickPrev'); });
        nextMobile.on('click', function () { slider.slick('slickNext'); });

        // slider.on('afterChange', function(slick, currentSlide) {
        //     if(currentSlide.currentSlide === 0) {
        //         $('#project-gallery-slick-prev-mobile').addClass('slick-disabled');
        //         $('#project-gallery-slick-next-mobile').removeClass('slick-disabled');
        //     } else if(currentSlide.currentSlide === (currentSlide.slideCount - 1)) {
        //         $('#project-gallery-slick-prev-mobile').removeClass('slick-disabled');
        //         $('#project-gallery-slick-next-mobile').addClass('slick-disabled');
        //     } else {
        //         $('#project-gallery-slick-prev-mobile').removeClass('slick-disabled');
        //         $('#project-gallery-slick-next-mobile').removeClass('slick-disabled');
        //     }
        // });

    });
}
